import { createContext } from "react";
import { components } from "../ApiSchema";

const Context = createContext<components["schemas"]["RfqFullSchema"] | null>(
  null,
);

export default Context;
